var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cover-table"},[_c('Table',{staticStyle:{"width":"100%"},attrs:{"border":"","loading":_vm.loading,"columns":_vm.tableColumns,"data":_vm.tableData,"highlight-row":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }